import { useLenderStrategies } from "@bridgesplit/abf-react";
import { useLenderStrategiesPagination } from "app/api";

import { StrategyCards } from "../../strategy";
import { useMarketContext } from "../common";

export default function LendExistingStrategies() {
    const pagination = useLenderStrategiesPagination();
    const { principalMint } = useMarketContext();

    const { data: strategies, totalStrategies } = useLenderStrategies({
        filter: {
            ...pagination.backendPagination,
            principalMints: principalMint ? [principalMint] : undefined
        }
    });

    return (
        <StrategyCards
            strategies={pagination.visibleData(strategies)}
            defaultPrincipalMint={principalMint}
            pagination={pagination}
            totalStrategies={totalStrategies}
        />
    );
}
